import { Signal } from "typed-signals";
import { Rectangle } from "pixi.js";

import { Scene } from "onearm";
import { FullScreenBackgroundFill } from "onearm";

export class SystemSettingsPopupScene extends Scene {
    constructor(parameters) {
        super({ layer: "popups", ...parameters });
    }

    create(options) {
        super.create(options);

        const { screen, bet, currencyFormatter, isMusicMuted, isSfxMuted, isQuickSpin } = options;

        this.onPressClose = new Signal();
        this.onChangeQuickSpin = new Signal();
        this.onChangeAmbientMusic = new Signal();
        this.onChangeSoundFX = new Signal();
        this.onChangeIntroScreen = new Signal();
        this.onPressMinus = new Signal();
        this.onPressPlus = new Signal();
        this.onPressGameHistory = new Signal();
        this.onPressHome = new Signal();

        this.currencyFormatter = currencyFormatter;
        this.fill = this.addChild(
            new FullScreenBackgroundFill({
                fullScreenZone: screen.zone.fullScreen,
                color: 0x000000,
                alpha: 0.8,
            }),
        );
        this.settingsPopup = this.buildLayout("SettingsPopup");
        this.settingsPopup.forAll("CloseButton", (closeButton) => {
            closeButton.onPress.connect(() => this.onPressClose.emit());
        });
        this.settingsPopup.forAll("QuickSpinToggle", (quickSpinToggle) => {
            quickSpinToggle.onChange.connect((value) => this.onChangeQuickSpin.emit(value));
        });
        this.settingsPopup.forAll("AmbientMusicToggle", (ambientMusicToggle) => {
            ambientMusicToggle.setState(!isMusicMuted);
            ambientMusicToggle.onChange.connect((value) => this.onChangeAmbientMusic.emit(value));
        });
        this.settingsPopup.forAll("SoundFXToggle", (soundFXToggle) => {
            soundFXToggle.setState(!isSfxMuted);
            soundFXToggle.onChange.connect((value) => this.onChangeSoundFX.emit(value));
        });
        this.settingsPopup.forAll("IntroScreenToggle", (introScreenToggle) => {
            introScreenToggle.onChange.connect((value) => this.onChangeIntroScreen.emit(value));
        });
        this.settingsPopup.forAll("MinusButton", (minusButton) => {
            minusButton.onPress.connect(() => this.onPressMinus.emit());
        });
        this.settingsPopup.forAll("PlusButton", (plusButton) => {
            plusButton.onPress.connect(() => this.onPressPlus.emit());
        });
        this.settingsPopup.forAll("GameHistoryLink", (gameHistoryLink) => {
            const button = this.makeButton(gameHistoryLink);

            button.onPress.connect(() => this.onPressGameHistory.emit());
        });
        this.settingsPopup.forAll("HomeLink", (homeLink) => {
            const button = this.makeButton(homeLink);
            button.onPress.connect(() => this.onPressHome.emit());
        });

        this.setBet(bet);

        this.onChangeQuickSpin.connect(this.handleChangeQuickSpin.bind(this));
        this.onChangeAmbientMusic.connect(this.handleChangeAmbientMusic.bind(this));
        this.onChangeSoundFX.connect(this.handleChangeSoundFX.bind(this));
        this.onChangeIntroScreen.connect(this.handleChangeIntroScreen.bind(this));
    }

    handleChangeQuickSpin(value) {
        this.settingsPopup.forAll("QuickSpinToggle", (quickSpinToggle) => {
            quickSpinToggle.setState(value);
        });
    }

    handleChangeAmbientMusic(value) {
        this.settingsPopup.forAll("AmbientMusicToggle", (ambientMusicToggle) => {
            ambientMusicToggle.setState(value);
        });
    }

    handleChangeSoundFX(value) {
        this.settingsPopup.forAll("SoundFXToggle", (soundFXToggle) => {
            soundFXToggle.setState(value);
        });
    }

    handleChangeIntroScreen(value) {
        this.settingsPopup.forAll("IntroScreenToggle", (introScreenToggle) => {
            introScreenToggle.setState(value);
        });
    }

    setBet(bet) {
        this.settingsPopup.forAll("BetsValueText", (betText) => {
            betText.text = this.currencyFormatter.format(bet);
        });
    }

    makeButton(displayObject) {
        displayObject.interactive = true;
        displayObject.buttonMode = true;
        displayObject.cursor = "pointer";
        displayObject.onPress = new Signal();
        displayObject.on("pointerdown", () => {
            displayObject.onPress.emit();
        });

        displayObject.hitArea = new Rectangle(0, 0, displayObject.width, displayObject.height);

        return displayObject;
    }
}
